(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-reviews"] && !Shopify.designMode) return;
  try {
    
class ArtReviews extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.swiper');
    this.nextBtn = this.querySelector('.next');
    this.prevBtn = this.querySelector('.prev');

    this.swiper = null;

    this._resizeTimer = null;
    this._lastSlidesPerView = null;

    this._waiting = false;
    this._maxWaitMs = 3000;
    this._pollIntervalMs = 50;
  }

  connectedCallback() {
    this.ensureSwiper();

    window.addEventListener('resize', this.onResize, { passive: true });
    document.addEventListener('shopify:section:load', this.onSectionLoad);
    // Echte Trusted-Shops-Reviews wurden ins .swiper-wrapper gerendert → Swiper neu aufbauen
    this.addEventListener('ts:reviews-loaded', this.onTsReviews);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
    this.removeEventListener('ts:reviews-loaded', this.onTsReviews);
    this.destroySwiper();
  }

  onTsReviews = () => {
    this.ensureSwiper(true);
  };

  onSectionLoad = (event) => {
    if (event?.target && event.target.contains(this)) {
      this.ensureSwiper(true);
    }
  };

  onResize = () => {
    if (!this.slider) return;

    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      const spv = this.computeSlidesPerView();
      if (spv !== this._lastSlidesPerView) {
        this.ensureSwiper(true);
      }
    }, 150);
  };

  computeSlidesPerView() {
    const w = window.innerWidth;
    if (w >= 1100) return 3;
    if (w >= 990) return 2;
    return 1;
  }

  destroySwiper() {
    if (this.swiper) {
      try {
        this.swiper.destroy(true, true);
      } catch (e) {
      }
      this.swiper = null;
    }
  }

  async ensureSwiper(forceReinit = false) {
    if (!this.slider) return;

    if (this.swiper && !forceReinit) return;

    if (forceReinit) this.destroySwiper();

    const ok = await this.waitForGlobalSwiper();
    if (!ok) {
      console.warn('[ArtReviews] Swiper ist nicht verfügbar (zu spät/nie geladen).');
      return;
    }

    this.initSwiper();
  }

  waitForGlobalSwiper() {
    if (typeof window.Swiper === 'function') return Promise.resolve(true);

    if (this._waiting) return Promise.resolve(false);
    this._waiting = true;

    return new Promise((resolve) => {
      const start = performance.now();

      const tick = () => {
        if (typeof window.Swiper === 'function') {
          this._waiting = false;
          resolve(true);
          return;
        }

        if (performance.now() - start >= this._maxWaitMs) {
          this._waiting = false;
          resolve(false);
          return;
        }

        setTimeout(tick, this._pollIntervalMs);
      };

      tick();
    });
  }

  initSwiper() {
    if (this.swiper) return;

    const spv = this.computeSlidesPerView();
    this._lastSlidesPerView = spv;

    this.swiper = new window.Swiper(this.slider, {
      loop: true,
      autoplay: false,
      speed: 400,
      spaceBetween: 30,
      slidesPerView: 1,
      breakpoints: {
        750: { slidesPerView: 1 },
        990: { slidesPerView: 2 },
        1100: { slidesPerView: 3 }
      },
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
        disabledClass: 'nav--disabled'
      }
    });
  }
}

customElements.define('art-reviews', ArtReviews);

  } catch(e) { console.error(e); }
})();
})();
